export const isTaskInTodos = (task, todoDays, allTodoDays, allTodos) => {
    let isInTodos = false

    if (todoDays && allTodoDays) {
        const lastTodoDayId = todoDays[(todoDays.length - 1)]
        const lastToDoDay = allTodoDays[lastTodoDayId]

        if (!lastToDoDay) {
            return false
        }

        lastToDoDay.todos.forEach(todoId => {
            const todo = allTodos[todoId]

            if (todo && todo.task_id == task.id) {
                isInTodos = true;
                return
            }
        })
    }

    return isInTodos
}

export const randomTaskName = _ => {
    const longString = '####################################'
    let randomStringLength = Math.round((Math.random() * 50))

    if (randomStringLength < 5) {
        randomStringLength = 5
    }

    return longString.substring(0, randomStringLength)
}

export const getPrimaryColumnValue = (type, task, project, columnId = null, returnColumn = false, _column) => {
    let failReturnValue = null

    switch (type) {
        case 'people':
            failReturnValue = []
            break
        case 'date':
            failReturnValue = {
                start: null,
                end: null
            }
            break
    }

    if (!_column && (!project || !project.columns || !type)) {
        return failReturnValue
    }
    
    let column = null

    if (!_column) {

        project.columns.forEach(loopedColumn => {
            if (loopedColumn.type.toLowerCase() == type) {
                if (!column) {
                    if (!columnId && loopedColumn.is_primary) {
                        column = loopedColumn
                    } else if (columnId && loopedColumn.id === columnId) {
                        column = loopedColumn
                    }
                }
            }
        })
    } else {
        column = _column
    }

    if (returnColumn) {
        return column
    }

    if (!column || !task) {
        return failReturnValue
    }

    if (task.column_data && task.column_data[column.id]) {
        let response = task.column_data[column.id]

        if(type === 'date'){
            Object.keys(response).forEach(key => {
                if(response[key] === 'Invalid date'){
                    response = {...response}
                    response[key] = null
                }
            })
        }

        return response
    } else {
        return failReturnValue
    }
}

export const getApplicableUsers = (currentAccount, allUsers, currentProject, allTeams) => {
    const userIds = []
    const users = []

    if (!currentAccount || !currentProject) {
        return []
    }

    // If premium and not public, get teams, admins and PMs. Otherwise, just get everyone.
    if (!currentProject.is_public) {
        currentProject.teamIds && currentProject.teamIds.forEach(teamId => {
            const team = allTeams[teamId]

            if (!team) {
                return
            }

            team.userIds.forEach(userId => {
                if (userIds.indexOf(userId) === -1) {
                    userIds.push(userId)
                }
            })
        })

        currentAccount.adminIds && currentAccount.adminIds.forEach(adminId => {
            if (userIds.indexOf(adminId) === -1) {
                userIds.push(adminId)
            }
        })

        currentAccount.pmIds && currentAccount.pmIds.forEach(pmId => {
            if (userIds.indexOf(pmId) === -1) {
                userIds.push(pmId)
            }
        })
    } else {
        currentAccount.users && currentAccount.users.forEach(userId => {
            if (currentAccount.guestIds && currentAccount.guestIds.indexOf(userId) === -1) {
                userIds.push(userId)
            }
        })
    }

    currentProject.guestIds && currentProject.guestIds.forEach(guestId => {
        if (userIds.indexOf(guestId) === -1) {
            userIds.push(guestId)
        }
    })

    const valuesToIgnore = ['chats', 'account', 'accounts', 'collapsed_milestones', 'email_preference', 'history_items', 'notifications', 'pivot', 'projectIds', 'todo_days']

    userIds.forEach(userId => {
        const user = allUsers[userId]

        let userDataToAdd = {
            ...user
        }

        valuesToIgnore.forEach(value => {
            delete userDataToAdd[value]
        })

        users.push(userDataToAdd)
    })

    users.sort((a, b) => {
        return (a.first_name < b.first_name) ? -1 : (a.first_name > b.first_name) ? 1 : 0;
    })

    return users
}


// WEBPACK FOOTER //
// ./src/utils/task.js